<template>
    <div id="Lcertificate">
        <div class="">
            <div class="LcertificateTitle">添加二类专业学时</div>
            <div class="LcertificateForm">
                <Form ref="formValidate" :model="formValidate" :label-width="100">            
                        <Row>
                            <Col span="12">
                                <FormItem label="自修项目类型">
                                    <Select v-model="formValidate.types" placeholder="请选择自修项目类型" >
                                        <Option v-for="(item,index) in data" :key="index" :value="item.id">{{item.majorName}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="12">
                                <FormItem label="年度">
                                    <Select v-model="formValidate.years" placeholder="请选择年度">
                                        <Option :value="item.value" v-for="(item,index) in yearsArr" :key="index">{{item.label}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="12">
                                <FormItem label="自修项目性质" >
                                    <Select v-model="formValidate.nature" placeholder="请选择自修项目性质" @on-change="changeType(formValidate.nature)">
                                        <Option  v-for="(item,index) in typesArr" :key="index" :value="item.id">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="12">
                                <FormItem :label="academy" >
                                    <Input v-model="formValidate.names" placeholder="请输入项目名称"></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        
                        <Row>
                            <Col span="12">
                                <FormItem label="范围级别" v-if="flag">
                                    <Select v-model="formValidate.scope" placeholder="请选择范围级别">
                                       <Option  v-for="(item,index) in natureArr" :key="index" :value="item.id">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row v-if="num==1">
                            <Col span="12">
                                <FormItem label="刊物名" >
                                    <Input v-model="formValidate.sci" placeholder="请输入刊物名"></Input>
                                </FormItem>
                            </Col>
                        </Row>       
                        <Row v-if="num==5">
                            <Col span="12">
                                <FormItem label="文章字数" >
                                    <Input v-model="formValidate.sci" placeholder="请输入文章字数"></Input>
                                </FormItem>
                            </Col>
                        </Row>       
                        <Row v-if="num==4">
                            <Col span="12">
                                <FormItem label="专利号" >
                                    <Input v-model="formValidate.sci" placeholder="请输入专利号"></Input>
                                </FormItem>
                            </Col>
                        </Row>       
                        <Row v-if="num==6 || num==7">
                            <Col span="12">
                                <FormItem :label="course" >
                                    <Input v-model="formValidate.sci" placeholder="请输入举办单位"></Input>
                                </FormItem>
                            </Col>
                        </Row>       
                        <Row>
                            <Col span="12">
                                <FormItem label="证明上传">
                                    <div v-if="flag1">
                                        <div class="demo-upload-list"  v-for="(item,index) in srcArr" :key="index" >
                                            <div>
                                                <img :src="item.imageUrl" />
                                                <div class="demo-upload-list-cover">
                                                    <Icon type="ios-eye-outline" @click.native="handleView(index)"></Icon>
                                                    <Icon type="ios-trash-outline" @click.native="handleRemove(index)"></Icon>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Upload :headers="{ 'Access-Control-Allow-Origin': '*' }" ref="upload" name="img"
                                        :show-upload-list="false"
                                        :default-file-list="defaultList"
                                        :format="['jpg', 'jpeg', 'png', 'pdf', 'gif']"
                                        :max-size="2048"
                                        :on-format-error="handleFormatError"
                                        :on-exceeded-size="handleMaxSize"
                                        :on-success="handleBeforeUpload"
                                        multiple
                                        type="drag"
                                        :action='action'
                                        style="display: inline-block; width: 58px"
                                        class="Uploadaa"
                                        >
                                    <div class="Iconb">
                                        <Icon type="ios-camera" size="20"></Icon>
                                    </div>
                                    </Upload>
                                    <!-- 展示放大图片 -->
                                    <Modal title="预览" v-model="visible" >
                                        <img v-if="visible" style="width: 100%" :src="big" />
                                    </Modal>
                                </FormItem>
                            </Col>
                        </Row>
                        <FormItem>
                            <Button class="lBtn1" type="primary" @click="add()">添加</Button>
                            <Button class="lBtn2" type="primary" @click="getBack()">返回</Button>
                        </FormItem>       
                </Form>
            </div>
        </div>
    </div>
</template>
<script>
import {querySelfConfig,addSelfPeriod} from "../../../network/home.js";
import { getSelectMajor} from "../../../network/LPersonal";
import Cookies from "js-cookie";
export default {
    data(){
        return{
             formValidate: {
                    names: '',
                    types: '',
                    years: '',
                    sci: '',
                    nature: '',
                    scope: '',
                },
            visible:false,
            src:"",
            big:"",
            defaultList: [],
            typesArr: [],
            natureArr: [],
            flag:true,
            flag1:true,
            academy: '项目名称',
            course: '举办单位',
            action:  process.env.VUE_APP_BASE + "/oss/postfile",
            srcArr:[],
            yearsArr:[],
            data:[],
            num:0

        }
    },
    activated(){
        this.Get()
        this.get()
        this.querySelfConfig()
        this.time()
        if(this.srcArr.length < 1 ){
            this.flag1 = false
        } else{
            this.flag1 = true
        }
    },
    created(){
        this.Get()
        this.get()
        this.querySelfConfig()
        this.time()
        if(this.srcArr.length < 1 ){
            this.flag1 = false
        } else{
            this.flag1 = true
        }
        
    },
    methods:{
        Get(name) {
            return Cookies.get(`admin-${name}`);
        },
        time() {
            var myDate = new Date();
            var year = myDate.getFullYear(); //获取当前年
            this.yearsModel = year;
            this.initSelectYear(year);
        },
        initSelectYear(year) {
            this.yearsArr = [];
            for (let i = 0; i < 30; i++) {
                this.yearsArr.push({ value: year - i, label: year - i + "年" });
            }
        },
        changeType(e){
            this.num = e
            console.log(e)
           querySelfConfig({
                parentId:e
            }).then(res=>{
              console.log(res,"项目分类二级");
              this.natureArr = res.data.data
              if(this.natureArr.length){
                  this.flag=true
              } else{
                  this.flag = false
              }
              if(e === 6){
                  this.academy = '院校名称';
                  this.course = '通过课程';
              }
              else if(e === 7){
                  this.course = '举办单位和培训时间';
              }
              else{
                  this.academy = '项目名称';
                  this.course = '举办单位';
              }
              this.$forceUpdate();
            })
        },
        add(){
           addSelfPeriod({
               year:this.formValidate.years,
               userId:this.Get("userId"),
               majorId:this.formValidate.types,
               name:this.formValidate.names,
               upload:this.src,
               projectType:this.formValidate.nature,
               projectInfoType:this.formValidate.scope,
               projectInfo:this.formValidate.sci
           }).then(res=>{
            console.log(res);
            if(res.data.code==200){
                this.$Message.success(res.data.msg)
            }else{
                this.$Message.error(res.data.msg)
            }
        })
        },
        querySelfConfig(){
            querySelfConfig({
                parentId:0
            }).then(res=>{
              console.log(res,"项目分类一级");
              this.typesArr = res.data.data
            })
        },
        getBack() {
            this.$router.go(-1);
        },
        handleView(index) {
            this.srcArr.forEach((item,i)=>{
                this.big = this.srcArr[index].imageUrl
            })
            this.visible = true;
        },
        handleRemove(index) {
            this.srcArr.forEach((item,i)=>{
                this.srcArr.splice(index,1)
            })
        },
        handleFormatError() {
            this.$Notice.warning({
                title: "文件格式不正确",
                desc: "文件格式不正确，请选择jpg或png.",
            });
        },
        handleMaxSize() {
            this.$Notice.warning({
                title: "文件限制大小",
                desc: "文件大小不能超过2M",
            });
        },
        handleBeforeUpload(res) {
            this.srcArr.push(res.data.data)
            this.src = res.data.data.imageUrl;
            if(this.srcArr.length < 1 ){
                this.flag1 = false
            } else{
                this.flag1 = true
            }
            this.srcArr.forEach((item,i)=>{
                this.src += this.srcArr[i].imageUrl + ","
            })
        },
        get(){
            getSelectMajor().then((res) => {
                console.log(res, "我的订单");
                this.data = res.data.data;
                this.data.forEach((item,i)=>{
                    if(this.data[i].majorName=="执业药师"){
                        this.data.splice(i,1)
                    }
                })
            });
        }
    }
    
}
</script>
<style scoped>

</style>